module.exports = __webpack_public_path__ + "static/media/WarmScript-Regular.ede02e40.otf";